import React from 'react';
import { Modal } from 'react-bootstrap';
import { func, bool, string, number, oneOfType } from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import {mobileStyle} from './style';

function Presenter({onChangeMinute,onChangeSec,sec,min,onSubmit,show,onCancel,className,t}){
	return (
		<Modal 
			className={className}
			show={show}
			onHide={onCancel}
			bsSize="large"
		>
			<Modal.Header>
				<mobileStyle.ModalHeader>
					{t('create-quiz.SetTimeLimit')}
				</mobileStyle.ModalHeader>
			</Modal.Header>
			<Modal.Body>
				<mobileStyle.Wrapper>
					<mobileStyle.SelectWrapper>
						<select onChange={onChangeMinute} value={min}>
							{[0,1,2,3,4,5,6,7,8,9,10,15,20,30,60].map(val=>{
								return (
									<option key={val} value={val}>{val}</option>
								);
							})}
						</select>
						<span>MIN</span>
					</mobileStyle.SelectWrapper>
					<mobileStyle.SelectWrapper>
						<select onChange={onChangeSec} value={sec}>
							{[0,1,2,3,4,5,6,7,8,9,10,15,20,30,60].map(val=>{
								return (
									<option key={val} value={val}>{val}</option>
								);
							})}
						</select>
						<span>SEC</span>
					</mobileStyle.SelectWrapper>
				</mobileStyle.Wrapper>
			</Modal.Body>
			<Modal.Footer>
				<mobileStyle.ButtonWrapper>
					<mobileStyle.OkButton onClick={onSubmit}>OK</mobileStyle.OkButton>
				</mobileStyle.ButtonWrapper>
			</Modal.Footer>
		</Modal>
	);
}

Presenter.propTypes = {
	className : string,
	show : bool.isRequired,
	onChangeSec : func.isRequired,
	onChangeMinute : func.isRequired,
	sec : oneOfType([number,string]),
	min : oneOfType([number,string]),
	onSubmit : func.isRequired,
	onCancel : func.isRequired,
	t : func.isRequired
};

export default withNamespaces()(Presenter);